module.exports = __webpack_public_path__ + "static/media/AgentEmailAuto.78e92da4.svg";